export default __webpack_public_path__ + "static/media/3038.a892e8c9.jpg";